module.exports = __webpack_public_path__ + "static/media/humanities-award-bg.ba37cd35.jpg";